import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M6.5 9.667A.333.333 0 0 1 6.5 9M6.5 9.667A.333.333 0 0 0 6.5 9M10.5 9.667a.333.333 0 1 1 0-.667M10.5 9.667a.333.333 0 0 0 0-.667M6.5 14.333a.333.333 0 1 1 0-.667M6.5 14.333a.333.333 0 1 0 0-.667M10.5 14.333a.333.333 0 1 1 0-.667M10.5 14.333a.333.333 0 1 0 0-.667M14.5 9.667a.333.333 0 1 1 0-.667M14.5 9.667a.333.333 0 0 0 0-.667"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M3.833 4A1.333 1.333 0 0 0 2.5 5.333v11.334A1.333 1.333 0 0 0 3.833 18h13.334a1.333 1.333 0 0 0 1.333-1.333V5.333A1.334 1.334 0 0 0 17.167 4zM5.833 2v4M15.167 2v4"
    }, null, -1)
  ])))
}
export default { render: render }